/**
 * The v2 browse endpoints take latitude/longitude as *query params* (they are
 * validated off `req.query`), and reject a half-supplied pair outright — so
 * both halves go in together or neither does.
 */
export const currentCoordinates = () => {
  try {
    const stored = JSON.parse(localStorage.getItem("coordinates"));
    const lat = Number(stored?.lat);
    const lon = Number(stored?.lon);
    if (Number.isFinite(lat) && Number.isFinite(lon)) return { lat, lon };
  } catch {
    /* no usable coordinates stored */
  }
  return null;
};

/** Merges the stored coordinates into a query-param object, when we have them. */
export const withGeo = (params = {}, radiusKm) => {
  const coords = currentCoordinates();
  if (!coords) return params;
  return {
    ...params,
    latitude: coords.lat,
    longitude: coords.lon,
    ...(radiusKm ? { radiusKm } : {}),
  };
};
